import { render, staticRenderFns } from "./ReqHospClinDoc.vue?vue&type=template&id=f005fcb2"
import script from "./ReqHospClinDoc.vue?vue&type=script&lang=js"
export * from "./ReqHospClinDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports